export type SubjectContainerSlot = {
  teacherUuids: string[];
  roomUuids: string[];
  startDate: string | null; // ISO-Date 'YYYY-MM-DD', null wenn nicht platziert
  endDate: string | null; // ISO-Date 'YYYY-MM-DD', null wenn nicht platziert
};

/** Returns true if two date ranges overlap (inclusive). */
export function dateRangesOverlap(aStart: string, aEnd: string, bStart: string, bEnd: string): boolean {
  return aStart <= bEnd && bStart <= aEnd;
}

/** Slot with both dates set (i.e. placed). Unplatzierte Slots haben keinen Datumsbereich. */
export type PlacedSubjectContainerSlot = SubjectContainerSlot & { startDate: string; endDate: string };

/** Type guard: true wenn der Slot platziert ist (start- und endDate gesetzt). */
export function isPlaced(slot: SubjectContainerSlot): slot is PlacedSubjectContainerSlot {
  return slot.startDate !== null && slot.endDate !== null;
}

/** Returns true if any slot from mySlots and otherSlots share the given teacher AND overlap in date. */
export function teacherSlotsOverlap(
  mySlots: SubjectContainerSlot[],
  otherSlots: SubjectContainerSlot[],
  teacherUuid: string,
): boolean {
  const mine = mySlots.filter(isPlaced).filter((s) => s.teacherUuids.includes(teacherUuid));
  const other = otherSlots.filter(isPlaced).filter((s) => s.teacherUuids.includes(teacherUuid));
  return mine.some((m) => other.some((o) => dateRangesOverlap(m.startDate, m.endDate, o.startDate, o.endDate)));
}

/** Returns true if any slot from mySlots and otherSlots share the given room AND overlap in date. */
export function roomSlotsOverlap(
  mySlots: SubjectContainerSlot[],
  otherSlots: SubjectContainerSlot[],
  roomUuid: string,
): boolean {
  const mine = mySlots.filter(isPlaced).filter((s) => s.roomUuids.includes(roomUuid));
  const other = otherSlots.filter(isPlaced).filter((s) => s.roomUuids.includes(roomUuid));
  return mine.some((m) => other.some((o) => dateRangesOverlap(m.startDate, m.endDate, o.startDate, o.endDate)));
}
